import { render, staticRenderFns } from "./payManyTimesErrorOrder.vue?vue&type=template&id=70738793"
import script from "./payManyTimesErrorOrder.vue?vue&type=script&lang=js"
export * from "./payManyTimesErrorOrder.vue?vue&type=script&lang=js"
import style0 from "./payManyTimesErrorOrder.vue?vue&type=style&index=0&id=70738793&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports